import React, { useState, useEffect } from "react";
import "../styles/AboutUs.css";
import missionImage from "../assets/mision.png";
import teamImage from "../assets/training.png";



const Home = () => {
  const [showScrollButton, setShowScrollButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200) {
        setShowScrollButton(true);
      } else {
        setShowScrollButton(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="home-page">



      <div className="container text-animation-container">
        <div className="animated-textab">
          <div className=".container.visible ">
          </div>
          SSB Academy empowers individuals with quality training for success

        </div>
      </div>

 
      <div className="bg-image-containerabout">
        {/* <div className="centered-text">
          Prepare for Excellence
        </div> */}
      </div>

      <div className="abouthero-section">
        <h1>About SSB Academy</h1>
        <p>Your Gateway to Success in Defense Services</p>
      </div>

      <div className="mission-section">
        <img src={missionImage} alt="Our Mission" className="mission-image" />
        <div className="mission-text">
          <h2>Our Mission</h2>
          <p>
            At SSB Academy, our mission is to equip aspiring defense candidates with the 
            necessary skills, knowledge, and confidence to successfully clear the SSB 
            interview. We believe in shaping future leaders who can serve the nation 
            with honor and integrity.
          </p>
        </div>
      </div>

            {/* Our Values Section */}
            <div className="values-section">
        <h2>Our Core Values</h2>
        <ul>
          <li><strong>Excellence:</strong> Striving for the highest standards in training.</li>
          <li><strong>Integrity:</strong> Upholding honesty and discipline in all our teachings.</li>
          <li><strong>Dedication:</strong> Commitment to the success of each candidate.</li>
          <li><strong>Innovation:</strong> Adapting modern techniques for the best results.</li>
          <li><strong>Leadership:</strong> Encouraging candidates to develop strong leadership qualities.</li>
        </ul>
      </div>

      <div className="training-section">
        <h2>Our Training Approach</h2>
        <p>
          Our structured training programs focus on **psychological assessments, 
          group discussions, personal interviews, and physical fitness** to ensure 
          holistic preparation for the SSB interview. We emphasize practical learning 
          with **mock tests, simulations, and real-life problem-solving scenarios**.
        </p>
      </div>

           {/* Meet the Team Section */}
           <div className="team-section">
        <img src={teamImage} alt="Our Team" className="team-image" />
        <h2>Meet Our Experts</h2>
        <p>
          Our team consists of **ex-defense officers, SSB interview experts, and 
          psychological trainers** who bring years of experience in grooming future 
          officers. Each trainer is dedicated to mentoring and guiding candidates to 
          achieve their fullest potential.
        </p>
      </div>

      <div className="testimonials-section">
        <h2>What Our Candidates Say</h2>
        <div className="testimonial">
          <p>"SSB Academy's training program was a game-changer for me. I gained confidence and aced my SSB interview!"</p>
          <h4>- Rahul Sharma</h4>
        </div>
        <div className="testimonial">
          <p>"The mock tests and personal mentoring made a huge difference in my preparation. Highly recommended!"</p>
          <h4>- Priya Verma</h4>
        </div>
      </div>
      <div className="contact-section">
        <h2>Get in Touch</h2>
        <p>
          Have questions? Reach out to us at **contact@ssbacademy.com** or visit 
          our training center for a consultation.
        </p>
      </div>


   




     



      {showScrollButton && (
        <div className="scroll-to-top">
          <button onClick={scrollToTop}>
            ↑
          </button>
        </div>
      )}
    </div>
  );
};

export default Home;